var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modalNouvelleCommande",
      attrs: {
        size: "xl",
        title: "Créer une commande",
        "no-close-on-backdrop": ""
      },
      on: {
        show: function($event) {
          return _vm.initialiserModale()
        },
        shown: function($event) {
          return _vm.$refs.nomCommandeCreation.focus()
        }
      }
    },
    [
      _c("template", { slot: "default" }, [
        _c(
          "div",
          { staticClass: "container" },
          [
            _c("div", { staticClass: "form-group" }, [
              _c("label", { attrs: { for: "nomCommande" } }, [
                _vm._v("Nom de la commande")
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.optionsCreation.nom,
                    expression: "optionsCreation.nom",
                    modifiers: { trim: true }
                  }
                ],
                ref: "nomCommandeCreation",
                staticClass: "form-control",
                attrs: { type: "text", id: "nomCommande", maxlength: "80" },
                domProps: { value: _vm.optionsCreation.nom },
                on: {
                  focus: function($event) {
                    return $event.target.select()
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.optionsCreation,
                      "nom",
                      $event.target.value.trim()
                    )
                  },
                  blur: function($event) {
                    return _vm.$forceUpdate()
                  }
                }
              }),
              !_vm.$v.optionsCreation.nom.required
                ? _c("div", { staticClass: "error" }, [
                    _vm._v("Ce champ est requis")
                  ])
                : _vm._e(),
              !_vm.$v.optionsCreation.nom.minLength
                ? _c("div", { staticClass: "error" }, [
                    _vm._v("Ce champ doit contenir au moins 3 caractères")
                  ])
                : _vm._e()
            ]),
            _vm._l(_vm.optionsCreation.parametreCreation, function(
              param,
              iParam
            ) {
              return _c("div", { key: iParam }, [
                _c(
                  "div",
                  { key: _vm.key, staticClass: "card border-secondary" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "card-header flex-center-space-between",
                        class:
                          !param.dateDebut ||
                          !param.dateFin ||
                          !param.menusPlansIds.length ||
                          !param.servicesIds.length
                            ? "bg-danger"
                            : ""
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              "Menus du " +
                                ([
                                  _vm.formatHumanDate(param.dateDebut),
                                  _vm.formatHumanDate(param.dateFin)
                                ]
                                  .filter(function(p) {
                                    return p
                                  })
                                  .join(" au ") || "...")
                            )
                          )
                        ]),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: {
                                  content: "Supprimer cette période de menus"
                                },
                                expression:
                                  "{ content: 'Supprimer cette période de menus'}"
                              }
                            ],
                            staticClass: "btn btn-danger btn-sm",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.supprimerPeriode(iParam)
                              }
                            }
                          },
                          [_c("i", { staticClass: "fas fa-trash" })]
                        )
                      ]
                    ),
                    _c("div", { staticClass: "card-body" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-12" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c("SelectDatesMenusPlansServices", {
                                attrs: {
                                  multiLigne: true,
                                  periodeMenus: param,
                                  dateDebut: param.dateDebut,
                                  dateFin: param.dateFin,
                                  menuPlanIds: param.menusPlansIds,
                                  serviceIds: param.servicesIds,
                                  viderMenusPlans: "Vider"
                                },
                                on: {
                                  "changer-dms": function($event) {
                                    return _vm.changerParametresMenus(
                                      iParam,
                                      $event
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ])
                    ])
                  ]
                )
              ])
            })
          ],
          2
        )
      ]),
      _c("template", { slot: "modal-footer" }, [
        _c("div", { staticClass: "flex-center-space-between w-100" }, [
          _c(
            "button",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: { content: "Ajouter une période de menus" },
                  expression: "{ content: 'Ajouter une période de menus'}"
                }
              ],
              staticClass: "btn btn-primary",
              attrs: { type: "button", disabled: !_vm.estValide },
              on: {
                click: function($event) {
                  return _vm.ajouterPeriode()
                }
              }
            },
            [_vm._v("Ajouter une période de menus")]
          ),
          _c("div", [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary mr-2",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.hide()
                  }
                }
              },
              [_vm._v("Annuler")]
            ),
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: {
                  type: "button",
                  disabled:
                    !_vm.$v.optionsCreation.nom.required ||
                    !_vm.$v.optionsCreation.nom.minLength ||
                    !_vm.estValide
                },
                on: {
                  click: function($event) {
                    return _vm.creerCommande()
                  }
                }
              },
              [_vm._v("Créer")]
            )
          ])
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }